module.exports = {
  editor: {
    cell_config: [],    // 移动端配置：10图片上传60表情
    cell_dir_name: 'upload',    // 移动端上传文件夹名称
    pc_config: [],  // pc端配置
    pc_code_type: 'javascript', // pc端默认代码类型
    pc_dir_name: 'upload',  // pc端上传文件夹名称
    pc_file_max: 2, // pc端文件大小限制
    pc_file_unit: 20,   // pc端文件大小单位
    pc_map_key: '', // pc端百度地图秘钥
    write_default: '',  // 默认值
    write_max: 200, // 最大长度限制
    write_min: 0,   // 最小长度限制
    checkAllPcMenu: false   // 全选
  }
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/editor.js